// Mock data for Evoluzione Tetto landing page

export const provinces = [
  "Agrigento", "Alessandria", "Ancona", "Aosta", "Arezzo", "Ascoli Piceno", "Asti",
  "Avellino", "Bari", "Barletta-Andria-Trani", "Belluno", "Benevento", "Bergamo",
  "Biella", "Bologna", "Bolzano", "Brescia", "Brindisi", "Cagliari", "Caltanissetta",
  "Campobasso", "Caserta", "Catania", "Catanzaro", "Chieti", "Como", "Cosenza",
  "Cremona", "Crotone", "Cuneo", "Enna", "Fermo", "Ferrara", "Firenze", "Foggia",
  "Forlì-Cesena", "Frosinone", "Genova", "Gorizia", "Grosseto", "Imperia", "Isernia",
  "L'Aquila", "La Spezia", "Latina", "Lecce", "Lecco", "Livorno", "Lodi", "Lucca",
  "Macerata", "Mantova", "Massa-Carrara", "Matera", "Messina", "Milano", "Modena",
  "Monza e Brianza", "Napoli", "Novara", "Nuoro", "Oristano", "Padova", "Palermo",
  "Parma", "Pavia", "Perugia", "Pesaro e Urbino", "Pescara", "Piacenza", "Pisa",
  "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Calabria",
  "Reggio Emilia", "Rieti", "Rimini", "Roma", "Rovigo", "Salerno", "Sassari", "Savona",
  "Siena", "Siracusa", "Sondrio", "Sud Sardegna", "Taranto", "Teramo", "Terni", "Torino",
  "Trapani", "Trento", "Treviso", "Trieste", "Udine", "Varese", "Venezia", "Verbano-Cusio-Ossola",
  "Vercelli", "Verona", "Vibo Valentia", "Vicenza", "Viterbo"
];

export const houseTypes = [
  "Casa indipendente",
  "Villetta a schiera",
  "Appartamento in condominio",
  "Rustico/Casale",
  "Villa",
  "Altro"
];

export const ownershipStatus = [
  "Proprietario",
  "Affittuario",
  "Amministratore di condominio",
  "Altro"
];

export const serviceFeatures = [
  {
    icon: "Shield",
    title: "Nessun ponteggio necessario",
    description: "Lavoriamo in sicurezza con sistemi di protezione individuale certificati"
  },
  {
    icon: "Euro",
    title: "Risparmio fino al 70%",
    description: "Elimini i costi di noleggio e montaggio ponteggi tradizionali"
  },
  {
    icon: "Clock",
    title: "Tempi rapidi",
    description: "Intervento completato in pochi giorni, senza attese per i ponteggi"
  },
  {
    icon: "CheckCircle2",
    title: "Garanzia certificata",
    description: "Tutti i nostri interventi sono garantiti e certificati"
  },
  {
    icon: "Users",
    title: "Tecnici specializzati",
    description: "Personale formato e certificato per lavori in quota"
  },
  {
    icon: "Leaf",
    title: "Sostenibilità",
    description: "Meno impatto ambientale, nessun ingombro per i vicini"
  }
];

export const servicesIncluded = [
  "Installazione linee vita provvisorie e sistemi anticaduta",
  "Impermeabilizzazione completa di comignoli e lucernari",
  "Revisione professionale del manto di copertura",
  "Redazione Piano Operativo di Sicurezza (POS)",
  "Fissaggio e controllo di coppi e tegole",
  "Pulizia completa di grondaie e pluviali",
  "Verifica dello stato delle lattonerie",
  "Documentazione fotografica pre e post intervento"
];

// Mock function to simulate form submission
export const submitLeadForm = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  console.log("Lead form submitted:", formData);
  
  // Store in localStorage for demo
  const leads = JSON.parse(localStorage.getItem('leads') || '[]');
  leads.push({
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('leads', JSON.stringify(leads));
  
  return {
    success: true,
    message: "Richiesta inviata con successo! Ti contatteremo entro 24 ore."
  };
};
